/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalSubmissionListEntry } from './PalSubmissionListEntry';
import {
    PalSubmissionListEntryFromJSON,
    PalSubmissionListEntryFromJSONTyped,
    PalSubmissionListEntryToJSON,
    PalSubmissionListEntryToJSONTyped,
} from './PalSubmissionListEntry';

/**
 * 
 * @export
 * @interface FindAllPalSubmissionsResponse
 */
export interface FindAllPalSubmissionsResponse {
    /**
     * 
     */
    data: Array<PalSubmissionListEntry>;
    /**
     * 
     */
    total: number;
    /**
     * 
     */
    page: number;
    /**
     * 
     */
    limit: number;
    /**
     * 
     */
    has_next: boolean;
    /**
     * User lookup map keyed by user_id. Each value matches the LeadAssignmentUser shape. Typed as an open object because the openapi-generator's TypeScript template emits broken FromJSON for typed-additionalProperties Records; consumers cast at use site.
     */
    users_sidecar?: { [key: string]: any; };
}

/**
 * Check if a given object implements the FindAllPalSubmissionsResponse interface.
 */
export function instanceOfFindAllPalSubmissionsResponse(value: object): value is FindAllPalSubmissionsResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('has_next' in value) || value['has_next'] === undefined) return false;
    return true;
}

export function FindAllPalSubmissionsResponseFromJSON(json: any): FindAllPalSubmissionsResponse {
    return FindAllPalSubmissionsResponseFromJSONTyped(json, false);
}

export function FindAllPalSubmissionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllPalSubmissionsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(PalSubmissionListEntryFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
        'has_next': json['has_next'],
        'users_sidecar': json['users_sidecar'] == null ? undefined : json['users_sidecar'],
    };
}

export function FindAllPalSubmissionsResponseToJSON(json: any): FindAllPalSubmissionsResponse {
    return FindAllPalSubmissionsResponseToJSONTyped(json, false);
}

export function FindAllPalSubmissionsResponseToJSONTyped(value?: FindAllPalSubmissionsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(PalSubmissionListEntryToJSON)),
        'total': value['total'],
        'page': value['page'],
        'limit': value['limit'],
        'has_next': value['has_next'],
        'users_sidecar': value['users_sidecar'],
    };
}

